import { initializeApp } from 'firebase/app';

import { FIREBASE_CONFIG } from './constants';

export const firebaseApp = initializeApp(FIREBASE_CONFIG);
